var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollBlock",staticClass:"panel4",staticStyle:{"padding":"10px"}},[_c('div',{staticStyle:{"margin":"0 auto","width":"200px"}},[_vm._t("default",function(){return [_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("加载更多...")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }